import { render, staticRenderFns } from "./VideoRow.vue?vue&type=template&id=a460d8fe&"
import script from "./VideoRow.vue?vue&type=script&lang=js&"
export * from "./VideoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports